import React from 'react';
import MDSpinner from 'react-md-spinner';

type Props = {
  color?: string;
  style?: any;
  size?: number;
  duration?: number;
};
class Spinner extends React.Component<Props> {
  constructor(props) {
    super(props);
  }
  render() {
    const { color, style, size, duration } = this.props;
    return (
      <MDSpinner
        duration={duration}
        size={size}
        singleColor={`${color}`}
        style={style}
      />
    );
  }
}

export default Spinner;
